const formatTemplateTags = template => {
  if (!Array.isArray(template?.tags) || template.tags.length === 0) {
    return 'None';
  }

  return template.tags.filter(Boolean).join(', ');
};

const formatTemplateHierarchy = template => {
  const hierarchyParts = [
    template?.productCategory,
    template?.productName,
    template?.eventTypeCategory
  ].filter(Boolean);

  if (hierarchyParts.length === 0) {
    return 'None';
  }

  return hierarchyParts.join(' > ');
};

export const toTemplateDropdownOption = template => {
  const tagsLabel = formatTemplateTags(template);
  const hierarchyLabel = formatTemplateHierarchy(template);

  return {
    ...template,
    secondaryText: `Tags: ${tagsLabel}`,
    searchText: [
      template?.name,
      tagsLabel,
      hierarchyLabel,
      template?.productCategory,
      template?.productName,
      template?.eventTypeCategory
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
  };
};

export const toTemplateDropdownOptions = templates =>
  (templates || []).map(toTemplateDropdownOption);
